import { Injectable } from "@angular/core";
import { concatMap } from "rxjs/operators";
import { WebApiService } from '../web-api/web-api.service';

export interface Cloud {
  Name: string;
  Region: string;
  IdleTimeout?:number;
  Id: string;
  IsGovCloud: boolean;
}

@Injectable({
  providedIn: "root",
})

export class CloudService {
  constructor(
    private webApiService: WebApiService
  ) {}

  getClouds() {
    return this.webApiService
      .get<Cloud[]>(`/identity/clouds`, { addInstanceIdHeader: false, useDefaultConfiguration: true })
      .pipe(
        concatMap((c) => {
          return c;
        })
      );
  }
}
